import { createApiMutation } from "../../generated-factory";
import { apiClientManager } from "@app/stores/api-manager";
import type { UseDeleteItemRequest, UseDeleteItemData, UseDeleteTemplate2Request, UseDeleteTemplate2Data } from "@api/@types/activity-template";

export const useDeleteItem = createApiMutation<UseDeleteItemData, UseDeleteItemRequest>({
  mutationFn: (req) => apiClientManager.apis.activityTemplate.deleteItem(req as UseDeleteItemRequest),
});

export const useDeleteTemplate2 = createApiMutation<UseDeleteTemplate2Data, UseDeleteTemplate2Request>({
  mutationFn: (req) => apiClientManager.apis.activityTemplate.deleteTemplate2(req as UseDeleteTemplate2Request),
});

export type { UseDeleteItemRequest, UseDeleteItemData, UseDeleteTemplate2Request, UseDeleteTemplate2Data } from "@api/@types/activity-template";
